import { useCallback, useMemo } from 'react';
import { useFileReviewThread, type FileReviewAnchor, type UseFileReviewThreadOptions } from '@jarvis/platform-file-review';
import type { JarvisPdfHighlight } from './JarvisPdfViewer';
import type { PdfHighlightArea } from './pdfViewerTypes';

export function usePdfReviewThread(
  mountId: string,
  path: string,
  enabled: boolean,
  options?: UseFileReviewThreadOptions
) {
  const review = useFileReviewThread(mountId, path, enabled, options);

  const highlights: JarvisPdfHighlight[] = useMemo(() => {
    if (!review.thread) return [];
    return review.anchorsForKind('pdf').map((a: FileReviewAnchor) => {
      const msg = review.thread!.messages.find((m: { anchorId?: string | null }) => m.anchorId === a.id);
      return {
        id: a.id,
        areas: Array.isArray(a.areas) ? a.areas : [],
        selectedText: a.selectedText,
        comment: msg?.text
      };
    });
  }, [review.anchorsForKind, review.thread]);

  const commitHighlight = useCallback(
    async (payload: { areas: PdfHighlightArea[]; selectedText: string; comment: string }) => {
      return review.commitPdfAnchor(payload);
    },
    [review]
  );

  return {
    ...review,
    highlights,
    commitHighlight
  };
}
